import instance from '@/http/http.js';

//密码登录
function passwdlogin(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Users/loginMobilePasswd',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//验证图形验证码 发送手机验证码
function sendCodeLogin(params){
    return new Promise((resolve,reject)=>{
        instance.post('/System/sendCodeLogin',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//短信验证码登录
function loginMobileCode(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Users/loginMobileCode',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//注册
function registerMobile(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Users/registerMobile',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}

//忘记密码
function forgetPasswd(params){
    return new Promise((resolve,reject)=>{
        instance.post('/Users/forgetPasswd',params).then(res=>{
            resolve(res)
        }).catch(error=>{
            reject(error)
        })
    })
}
export {
  forgetPasswd,
  loginMobileCode,
  passwdlogin,
  registerMobile,
  sendCodeLogin,
};